import React, { useCallback, useEffect, useState } from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import ReactPagination from "components/shared/ReactPagination";
import ContentLoader_ from "helpers/ContentLoader_";
import { DATE_FORMAT_TIME, FORMAT_TEXT } from "helpers/common";
import { PAGE_LIMIT, TRANSACTION } from "helpers/viewContent";
import * as Path from "routes/paths";
import * as actions from "store/actions/index.js";
import { getList_ } from "store/services/commonService";

const ContentLoader = ContentLoader_;

const formatAmount = (amount) => {
  if (amount === undefined || amount === null || amount === "") {
    return "N/A";
  }
  return `$ ${amount}`;
};

const formatPaymentMethod = (method) => {
  if (method === 0 || method === "0") {
    return "Card";
  }
  if (method === 1 || method === "1") {
    return "Wallet";
  }
  if (method === 2 || method === "2") {
    return "Cash";
  }
  return method || "N/A";
};

const formatPaymentStatus = (status) => {
  if (status === "1" || status === 1) {
    return "Paid";
  }
  if (status === "0" || status === 0) {
    return "Pending";
  }
  return status || "N/A";
};

const getUserName = (user) => {
  const fullName = [user?.name, user?.last_name].filter(Boolean).join(" ");
  return fullName || "N/A";
};

const Listing = ({ dispatch, itemsCountPerPage, totalItemsCount }) => {
  const [activePage, setActivePage] = useState(1);
  const [listing, setListing] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchData = useCallback(async () => {
    try {
      let query = {
        url: "report/listTransactions",
        page: activePage,
        limit: PAGE_LIMIT,
        common: false,
        search_string: "",
      };
      setIsLoading(true);
      dispatch(actions.persist_store({ loader: false }));
      let res = await dispatch(getList_(query));
      setListing(res?.body?.data || []);
      setIsLoading(false);
    } catch (err) {
      setListing([]);
      setIsLoading(false);
      console.log(err);
    }
  }, [activePage, dispatch]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handlePageChange = (page) => {
    setActivePage(page);
    window.scrollTo(0, 0);
  };

  return (
    <>
      <Helmet title={TRANSACTION.CURRENT_MODULE} />
      <div className="page-header">
        <h3 className="page-title">
          <span className="page-title-icon bg-gradient-primary text-white me-2">
            <i className="mdi mdi-credit-card menu-icon"></i>
          </span>{" "}
          {TRANSACTION.CURRENT_MODULE}
        </h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to={Path.transaction}>{TRANSACTION.CURRENT_MODULE}</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              {TRANSACTION.CURRENT_LIST}
            </li>
          </ol>
        </nav>
      </div>
      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">
                <div className="row">
                  <div className="col-md-6">{TRANSACTION.CURRENT_LIST}</div>
                  <div className="col-md-4"></div>
                </div>
              </h4>
              <div className="table-responsive">
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th> ID </th>
                      <th> Transaction ID </th>
                      <th> User </th>
                      <th> Match </th>
                      <th> Paid Amount </th>
                      <th> Total Amount </th>
                      <th> Payment Method </th>
                      <th> Payment Status </th>
                      <th> Date </th>
                    </tr>
                  </thead>
                  {isLoading ? (
                    <tbody>
                      <tr>
                        <td colSpan="9">
                          <div className="loader-class">
                            <ContentLoader />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  ) : (
                    <tbody>
                      {listing?.length > 0 &&
                        listing.map((list, i) => {
                          return (
                            <tr key={list?.id || i}>
                              <td>{list?.id || "N/A"}</td>
                              <td>
                                {list?.transaction_id
                                  ? FORMAT_TEXT(list?.transaction_id)
                                  : "N/A"}
                              </td>
                              <td>
                                {FORMAT_TEXT(getUserName(list?.user))}
                                {list?.user_id ? ` (#${list?.user_id})` : ""}
                              </td>
                              <td>
                                {list?.match?.match_title
                                  ? list?.match?.match_title
                                  : list?.match_id || "N/A"}
                              </td>
                              <td>{formatAmount(list?.paid_amount)}</td>
                              <td>{formatAmount(list?.total_amount)}</td>
                              <td>{formatPaymentMethod(list?.payment_method)}</td>
                              <td>{formatPaymentStatus(list?.payment_status)}</td>
                              <td className="py-1">
                                {list?.date ? DATE_FORMAT_TIME(list?.date) : "N/A"}
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  )}
                </table>
              </div>
              {listing.length > 0 && (
                <div className="pagination-box-review">
                  <ReactPagination
                    activePage={activePage}
                    itemsCountPerPage={itemsCountPerPage}
                    totalItemsCount={totalItemsCount}
                    handlePageChange={handlePageChange}
                  />
                </div>
              )}
              {!isLoading && listing.length === 0 && (
                <div className="row">
                  <div className="col-md-6 pt-5">
                    <span>No data found...</span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToPros = (state) => {
  return {
    itemsCountPerPage: state.Common.itemsCountPerPage,
    totalItemsCount: state.Common.totalItemsCount,
    loader: state.Common.loader,
  };
};

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(mapStateToPros, mapDispatchToProps)(Listing);
